import React from 'react';
import { Box, HStack, Icon, Text } from '@chakra-ui/react';
import { FaShoppingCart } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useShoppingCartStore } from '../store/shoppingCartStore';

const ShoppingCartButton: React.FC = () => {
  const navigate = useNavigate();
  const itemCount = useShoppingCartStore((state) => state.getItemCount());

  const handleClick = () => {
    if (itemCount > 0) {
      navigate('/checkout');
    } else {
      navigate('/roster?t=U');
    }
  };

  return (
    <Box
      as="button"
      onClick={handleClick}
      sx={{
        WebkitBackdropFilter: 'blur(8px)',
        background: 'rgba(0, 46, 11, 0.1)',
        backdropFilter: 'blur(8px)',
      }}
      borderRadius="lg"
      p={2}
      borderColor="rgba(255, 255, 255, 0.1)"
      boxShadow="0 4px 6px rgba(0, 0, 0, 0.3)"
      cursor="pointer"
      _hover={{ 
        background: 'rgba(0, 46, 11, 0.2)',
      }}
      transition="all 0.2s"
      aria-label="Shopping cart"
      position="relative"
    >
      <HStack spacing={2} align="center">
        <Icon
          as={FaShoppingCart}
          color="white"
          w={5}
          h={5}
        />
        <Text fontSize="sm" color="white">
          Cart
        </Text>
      </HStack>
      {itemCount > 0 && (
        <Box
          position="absolute"
          top="-2"
          right="-2"
          bg="red.500"
          color="white"
          borderRadius="full"
          minW="18px"
          h="18px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          fontSize="xs"
          fontWeight="bold"
          border="2px solid"
          borderColor="rgba(0, 0, 0, 0.7)"
          boxShadow="0 2px 4px rgba(0, 0, 0, 0.3)"
          px={itemCount > 9 ? 1 : 0}
        >
          {itemCount > 99 ? '99+' : itemCount}
        </Box>
      )}
    </Box>
  );
};

export default ShoppingCartButton;

